import { render, staticRenderFns } from "./ProjectCard.vue?vue&type=template&id=2e2cf7e1&scoped=true&"
import script from "./ProjectCard.vue?vue&type=script&lang=js&"
export * from "./ProjectCard.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCard.vue?vue&type=style&index=0&id=2e2cf7e1&lang=scss&scoped=true&"
import style1 from "./ProjectCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2cf7e1",
  null
  
)

export default component.exports